export enum PermissionEnum {
  MemberCreateForApproval = 'MEMBER_CREATE_FOR_APPROVAL', // Kan skapa ny men hamnar som begärd uppdatering
  MemberCreateOverride = 'MEMBER_CREATE_OVERRIDE', // Kan förbigå validering
  MemberCreate = 'MEMBER_CREATE',
  MemberDelete = 'MEMBER_DELETE',
  MemberUpdate = 'MEMBER_UPDATE',
  MemberUpdateOverride = 'MEMBER_UPDATE_OVERRIDE', // Kan förbigå validering
  MemberReadAll = 'MEMBER_READ_ALL',
  MemberReadDistrict = 'MEMBER_READ_DISTRICT',
  MemberReadAssociation = 'MEMBER_READ_ASSOCIATION',
  MemberReadMe = 'MEMBER_READ_ME', // For member users
  MemberProfileCreate = 'MEMBERPROFILE_CREATE',
  MemberProfileRead = 'MEMBERPROFILE_READ',
  MemberProfileUpdate = 'MEMBERPROFILE_UPDATE',
  MemberProfileDelete = 'MEMBERPROFILE_DELETE',
  MemberApprove = 'MEMBER_APPROVE', // For updated requests
  AssociationCreate = 'ASSOCIATION_CREATE',
  AssociationRead = 'ASSOCIATION_READ',
  AssociationUpdate = 'ASSOCIATION_UPDATE',
  AssociationDelete = 'ASSOCIATION_DELETE',
  GroupMessageCreate = 'GROUPMESSAGE_CREATE',
  GroupMessageRead = 'GROUPMESSAGE_READ',
  GroupMessageUpdate = 'GROUPMESSAGE_UPDATE',
  GroupMessageDelete = 'GROUPMESSAGE_DELETE',
  GroupMessageSmsCreate = 'GROUPMESSAGESMS_CREATE',
  GroupMessageSmsRead = 'GROUPMESSAGESMS_READ',
  GroupMessageSmsUpdate = 'GROUPMESSAGESMS_UPDATE',
  GroupMessageSmsDelete = 'GROUPMESSAGESMS_DELETE',
  UserCreate = 'USER_CREATE',
  UserRead = 'USER_READ',
  UserUpdate = 'USER_UPDATE',
  UserDelete = 'USER_DELETE',
  FundraiserRead = 'FUNDRAISER_READ', // Insamling
  FundraiserUpdate = 'FUNDRAISER_UPDATE', // SPAR
  DepositCreate = 'DEPOSIT_CREATE', // Gåvor
  DepositRead = 'DEPOSIT_READ',
  InvoiceRead = 'INVOICE_READ',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceDelete = 'INVOICE_DELETE',
  AutogiroDelete = 'AUTOGIRO_DELETE',
  PaymentRead = 'PAYMENT_READ',
  SettingsRead = 'SETTINGS_READ',
  BGPaymentSharedAccountRead = 'BG_PAYMENT_SHAREDACCOUNT_READ',
  InvoiceAddressRead = 'INVOICEADDRESS_READ',
  InvoiceAddressReadAll = 'INVOICEADDRESS_READ_ALL',
  InvoiceAddressCreate = 'INVOICEADDRESS_CREATE',
  InvoiceAddressUpdate = 'INVOICEADDRESS_UPDATE',
  InvoiceAddressDelete = 'INVOICEADDRESS_DELETE',
  UserCreateAssociation = 'USER_CREATE_ASSOCIATION',
  UserUpdateAssociation = 'USER_UPDATE_ASSOCIATION',
  UserDeleteAssociation = 'USER_DELETE_ASSOCIATION',
  UserCreateDistrict = 'USER_CREATE_DISTRICT',
  UserUpdateDistrict = 'USER_UPDATE_DISTRICT',
  UserDeleteDistrict = 'USER_DELETE_DISTRICT',
  InvoiceCreateForCustomer = 'INVOICE_CREATE_FOR_CUSTOMER',
  MemberRegSettingsCreate = 'MEMBERREG_SETTINGS_CREATE',
  MemberRegSettingsRead = 'MEMBERREG_SETTINGS_READ',
  MemberRegSettingsUpdate = 'MEMBERREG_SETTINGS_UPDATE',
  MemberRegSettingsDelete = 'MEMBERREG_SETTINGS_DELETE',
  MemberRegWebFormRead = 'MEMBERREG_WEBFORM_READ',
  MemberRegWebFormUpdate = 'MEMBERREG_WEBFORM_UPDATE',
  DashboardEdit = 'DASHBOARD_EDIT', // Krävs för att anpassa startsidans dashboard
}
